import axiosHttp from "./interceptor.service";

const saveItLoginStatus = (payload) => {
    return axiosHttp.post("/feedback/saveItLoginStatus", payload);
};

const checkItLoginStatusToday = () => {
    return axiosHttp.get("/feedback/getItLoginStatusToday");
};

const getItLoginStatusReport = (params) => {
    return axiosHttp.get("/feedback/getItLoginStatusReport", { params });
};

const assignItResponsibility = (payload) => {
    return axiosHttp.post("/feedback/assignItResponsibility", payload);
};

export default {
    saveItLoginStatus,
    checkItLoginStatusToday,
    getItLoginStatusReport,
    assignItResponsibility,
};
